import { useNotes, useTask } from "@hq/client-react";
import type { PaneComponentProps } from "@hq/layout";
import { TaskDetail } from "@hq/tasks-ui";
import { Button } from "@z/ui";
import { FileText } from "lucide-react";
import { useEffect } from "react";
import { useWorkspace } from "../workspace/WorkspaceContext";

export function TaskPane({ pane }: PaneComponentProps) {
  const ws = useWorkspace();
  const taskId = String(pane.params.taskId);
  const { data: task } = useTask(taskId);
  const title = task?.title;
  const { data: notes } = useNotes();
  const source = notes?.find((n) => n.id === task?.sourceNoteId);

  useEffect(() => {
    if (title !== undefined && title !== pane.title) ws.setTitle(pane.id, title);
  }, [title, pane.id, pane.title, ws]);

  return (
    <TaskDetail
      taskId={taskId}
      source={
        task?.sourceNoteId && (
          <Button
            variant="ghost"
            size="sm"
            className="self-start text-fg-muted"
            disabled={!source}
            onClick={() => source && ws.open({ paneType: "note", noteId: source.id })}
          >
            <FileText />
            {source ? `From ${source.title}` : "Source note is in Trash or unavailable"}
          </Button>
        )
      }
      onClose={() => ws.close(pane.id)}
      onDeleted={() => ws.close(pane.id)}
      className="h-full overflow-y-auto px-6 py-7"
    />
  );
}
